export const educationData = [
    {
        id: 1,
        institution: 'Visvesvaraya National Institute of Technology, Nagpur',
        course: 'BTech in Computer Science',
        startYear: '2009',
        endYear: '2013'
    }
]